import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  PENDING_WITHDRAWALS_DOWNLOAD_REPORT_MUTATION_KEY,
  PENDING_WITHDRAWALS_DOWNLOAD_REPORT_URL,
  PENDING_WITHDRAWALS_PERMISSIONS,
} from '../constants';

export default function useDownloadPendingWithdrawalsReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [PENDING_WITHDRAWALS_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      PENDING_WITHDRAWALS_DOWNLOAD_REPORT_URL,
      payload,
      { permission: PENDING_WITHDRAWALS_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
